import * as Accountant from 'app/calcs/Accountant'
import * as ExpenseCalculators from 'app/calcs/expenses'
import { haveEnoughDataForSSACalculation } from 'app/calcs/SSA';
import { MaterialInput } from 'app/components'
import { RetirementAgeSelector } from 'app/components/form/RetirementAgeSelector'
import { HelpfulVideo } from 'app/components/HelpfulVideo'
import MaterialNumber from 'app/components/material/MaterialNumber';
import { IQuestionsGroupContainerProps, QuestionsGroupContainer } from 'app/containers/PipelineSection/QuestionGroupContainer'
import { IRetirementPerson, isValidPerson, isValidPersonForSSA, Profile, updateLifeExpectancy } from 'app/redux/Profile/model'
import { LifeExpectancyService } from 'app/services/LifeExpectancyService';
import * as utils from 'app/utils'
import { getBrandInfo } from 'config'
import { IHelpfulVideo } from 'config/interfaces';
import * as _ from 'lodash'
import * as moment from 'moment'
import * as React from 'react'
import { Button, FormGroup, Modal, Popover } from 'react-bootstrap'
import { Infobox } from '../../../../components/Infobox'

interface ISSAGPOContainerState {
  haveEnoughDataForSSA: boolean
  missingData: any[]
  profile: Profile
  showErrors: boolean
  nowShowingVideo: IHelpfulVideo
}

const aStyle = {
  maxWidth: '30vw'
}

class SSAGPOContainer extends QuestionsGroupContainer<IQuestionsGroupContainerProps, ISSAGPOContainerState> {
  state: ISSAGPOContainerState = {
    haveEnoughDataForSSA: false,
    missingData: [],
    profile: null,
    showErrors: true,
    nowShowingVideo: undefined
  }

  minPIA = 41
  maxPIA = 10000
  minAge = moment().subtract(20, 'years').month(0).date(1).format('YYYY-MM-DD')
  minSocialSecurityAge = 62
  maxSocialSecurityAge = 71
  debouncedSaveUpdatedProfile = _.debounce(() => this.saveUpdatedProfile(), 1000) // chose 1 second to ensure save happens if a page change occurs

  componentWillMount() {
    this.onAppStateUpdate((appState) => {
      // tslint:disable-next-line:no-console
      console.log('ssa intro app state change!')
      const profile = appState.Profile.getNative('info')
      if (profile) {
        const folks = profile.getImportantPeople()
        //const haveEnoughDataForSSA = this.evaluateReadiness(folks)
        const haveEnoughDataForSSA = haveEnoughDataForSSACalculation(folks)
        this.setState({ profile, haveEnoughDataForSSA })
      } else {
        this.setState({ profile })
      }
    })
  }

  evaluateReadiness(folks: IRetirementPerson[]): boolean {
    const missingData = (0 === folks.length) ? ['No member or spouse have been entered.'] : _.reduce(folks, (acc, person) => {
      if (isValidPerson(person)) {

        if (0 === person.PIA) {
          acc.push(<li>The PIA for {person.firstName} is missing.
            <Infobox>You will need a recent statement from the Social Security
            Administration. More information is available at their website
            &nbsp;<a href="https://www.ssa.gov/myaccount/statement.html" target="_blank">here</a>.
            <br/><br/>It is helpful to review your personal financial records before entering the ssa.gov website.
            Look up your Social Security benefit at your full retirement age. This amount is your Primary Insurance Amount.
            </Infobox>
          </li>)
        }

        // tslint:disable-next-line:no-console
        console.log('xxx age: ' + JSON.stringify(person.selectedRetirementAge))
        if (!person.selectedRetirementAge) {
          // tslint:disable-next-line:no-console
          console.log('bang!')
          acc.push(<li>The withdrawal age for {person.firstName} is missing.</li>)
        }
      } else {
        acc.push('not a valid peson: ' + JSON.stringify(person))
      }

      return acc
    }, []);

    this.setState({ missingData })
    return 0 === missingData.length
  }

  memberIsPresentForSSA(): boolean {
    const profile = this.state.profile
    if (!profile) { return false }

    return isValidPersonForSSA(profile.getHeadOfHousehold())
  }

  saveUpdatedProfile() {
    this.Actions.Profile.store(this.state.profile)
  }

  spouseIsPresentForSSA(): boolean {
    const profile = this.state.profile
    if (!profile) { return false }

    return isValidPersonForSSA(profile.getSpouse())
  }

  updatePerson<T extends keyof IRetirementPerson>(memberIndex: number, attr: T, value: IRetirementPerson[T]) {
    const profile = this.state.profile
    const member = this.state.profile.family.members[memberIndex]
    member[attr] = value
    // tslint:disable-next-line:no-console
    console.log('update profile "' + attr + '" for member ' + memberIndex + ' to ' + value)

    this.setState({ profile })
    this.debouncedSaveUpdatedProfile()

    if (this.state.haveEnoughDataForSSA) {
      // tslint:disable-next-line:no-console
      console.log('Looks like we need to calc SSA')
      Accountant.runSSAOptimizer(profile.getPeopleForSSA())
      .then(() => undefined)
    }
  }

  updateMember<T extends keyof IRetirementPerson>(attr: T, value: IRetirementPerson[T]) {
    return this.updatePerson(0, attr, value)
  }

  updateSpouse<T extends keyof IRetirementPerson>(attr: T, value: IRetirementPerson[T]) {
    return this.updatePerson(1, attr, value)
  }

  renderMemberSection() {
    const profile = this.state.profile
    if (!profile) { return null }

    const member = profile.getHeadOfHousehold()
    const memberIsPresent = !_.isUndefined(member)
    const govPensionForGPO = memberIsPresent ? member.govPensionForGPO : 0
    const memberNamePossessive = utils.personPossessive(member.firstName)

    return (<div className="memberSection">
      <h6 className="Question"><i className="fa fa-fw fa-user-circle text-success" />
      What is {memberNamePossessive} governmental pension?
      </h6>
      <div style={aStyle}>
        <FormGroup>
          <MaterialNumber
            formattedNumberMode
            showValidityErrors={this.state.showErrors}
            value={govPensionForGPO}
            onChange={(e) => {
              const v = this.toNumber(e.currentTarget.value)
              this.updateMember('govPensionForGPO', v)
            }}
            required
          />
        </FormGroup>
      </div>
    </div>)
  }

  renderSpouseSection() {
    const spouse = this.state.profile.getSpouse()
    if (!isValidPerson(spouse)) { return null }
    const govPensionForGPO = spouse.govPensionForGPO
    const spouseNamePossessive = utils.personPossessive(spouse.firstName)

    return (<div className="spouseSection">
      <br/><br/>
      <h6 className="Question"><i className="fa fa-fw fa-user-circle text-success" />
        What is {spouseNamePossessive} governmental pension?
      </h6>
      <div style={aStyle}>
        <FormGroup>
          <MaterialNumber
            formattedNumberMode
            showValidityErrors={this.state.showErrors}
            value={govPensionForGPO}
            onChange={(e) => {
              const v = this.toNumber(e.currentTarget.value)
              this.updateSpouse('govPensionForGPO', v)
            }}
            required
          />
        </FormGroup>
      </div>
    </div>)
  }

  renderMissingInfo(person: IRetirementPerson) {
    if (!person) { return null }
    if (!isValidPerson(person)) { return null }

    const missingInfo = []
    if (0 === person.PIA) {
      missingInfo.push(<li>The PIA for {person.firstName} is missing.</li>)
    }

    if (!person.selectedRetirementAge) {
      missingInfo.push(<li>The withdrawl age for {person.firstName} is missing.</li>)
    }

    return missingInfo
  }

  render() {
    return (
      <section className="ssaIntro">
        <h1>Reduction - GPO</h1>
        <h5 className="lead">
          The Governmental Pension Offset (GPO) is a reduction that applies to Social Security
          spousal and survivor benefits.  For information about the GPO click
          &nbsp;<a href="https://www.ssa.gov/pubs/EN-05-10007.pdf" target="_blank">here</a>.
        </h5>

        <h5 className="lead">
          Enter the estimated "gross" monthly amount of your pension from your government job not covered by Social Security.
        </h5>

        {this.renderMemberSection()}
        {this.renderSpouseSection()}

        <br />
        <h5 className="lead">If this situation does not apply to you, simply enter 0 above.</h5>

        <Button type="submit" bsStyle="primary" bsSize="lg" disabled={!this.state.haveEnoughDataForSSA}>
          Next
        </Button>

      </section >
    )
  }
}

const SSAGPOReduction = () => (
  <SSAGPOContainer
    header="Reduction - GPO" icon="" />
)

export {
  SSAGPOReduction
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/SSA/ReductionGPO/index.tsx